import React from "react";
import ConversationCard from "./ConversationCard";
import CircularProgress from "@mui/material/CircularProgress";
import { Icon } from "@iconify/react/dist/iconify.js";
import { filter_chats } from "../../../utils/constant";

export default function ConversationList({
  conversations,
  selectedChat,
  setSelectedChat,
  searchText,
  setSearchText,
  isLoadingChats,
}) {
  return (
    <div className="chatting-sidebar">
      <div className="mb-2">
        <input
          type="text"
          className="form-control search-chat-input"
          placeholder="Search or start new chat"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      <div className="chatting-list">
        {isLoadingChats ? (
          <div className="chatting-loader">
            <CircularProgress />
          </div>
        ) : conversations.length === 0 ? (
          <div className="text-center text-muted mt-5 px-3 no-chat-found">
            <Icon icon="hugeicons:message-add-02" width="70" className="mb-4" />
            <h5 className="fw-semibold mb-1">No Chats Found</h5>
            <p className="small">
              Start a conversation by searching for a user above
            </p>
          </div>
        ) : (
          filter_chats(conversations).map((conv) => {
            const isSelected =
              !!selectedChat &&
              ((selectedChat.id && selectedChat.id === conv.id) ||
                (selectedChat.conversation_id &&
                  conv.conversation_id &&
                  selectedChat.conversation_id === conv.conversation_id));

            return (
              <ConversationCard
                key={conv.id || conv.conversation_id}
                conversation={conv}
                selected={isSelected}
                onClick={() => setSelectedChat(conv)}
              />
            );
          })
        )}
      </div>
    </div>
  );
}
